import React, { useState } from "react";
import {   Copy } from "lucide-react";
import { toast } from "react-toastify";
import { Body,   } from "../UIKits/Typography/Typography";
import { formatCurrency } from "../../helper/helper";
import Button from "../UIKits/Button/Button";
import { usePowerPurchaseStore } from "../../store/buyPowerStore";
import { PaymentStatusCard, PaymentStatusCardProps } from "./PaymentStatusCard";
import { downloadReceipt } from "../../services/selfService";
import { downloadInvoiceFile } from "../../helper/downloadHelper";
     

const SuccessStep: React.FC<Omit<PaymentStatusCardProps, "status" | "children">> = (props) => {
  const { paymentResult, resetFlow , invoiceData} = usePowerPurchaseStore();

  const copyToken = () => {
    if (paymentResult?.token) {
      navigator.clipboard.writeText(paymentResult.token);
      toast.success("Token copied to clipboard");
    }
  };

  const [downloadingReceipt, setDownloadingReceipt] = useState(false);

  const  handleDownloadReceipt = async () => {
      setDownloadingReceipt(true);
  
      const invoiceNumber = invoiceData?.invoiceNumber  
      if (!invoiceNumber && !paymentResult?.receiptNumber) { 
        toast.error("Invoice or receipt number not found");
         setDownloadingReceipt(false);
        return
      }
      try {
        const response = await downloadReceipt({invoiceNumber: invoiceNumber, receiptNumber: paymentResult?.receiptNumber});
  
        if (response.data) {
          // This handles both base64 and URL automatically!
          downloadInvoiceFile(response.data, invoiceNumber?? paymentResult?.receiptNumber! , "receipt");
  
          toast.success("Receipt downloaded successfully");
        }
      } catch (error: any) {
        toast.error(error.data?.message || "Failed to download receipt");
      } finally {
        setDownloadingReceipt(false);
      }
    };
  const handleClose = () => {
    resetFlow();
    props.onClose();
  };

  if (!paymentResult) return null;

  return (
    <PaymentStatusCard {...props} status="success">
      <div className="  w-[60%] mt-4 mb-6">
        <Body color="secondary" className="!text-center">
          Your token has been successfully generated, and has been sent to{" "}
          <span className="font-medium text-foreground">{paymentResult?.email}</span>
        </Body>
      </div>

      {/* Receipt Summary */}
      <div className="w-full bg-gray-50 rounded-xl p-4 space-y-3">
        <Body variant="body-medium" color="primary" className="font-semibold">
          Receipt summary
        </Body>

        <div className="flex justify-between items-center">
          <Body variant="caption" color="tertiary">
            Generated Token
          </Body>
          <div className="flex items-center gap-2">
            <Body className="font-mono">{paymentResult.token}</Body>
            <button onClick={copyToken} className="p-1 hover:bg-gray-200 rounded transition-colors">
              <Copy className="w-4 h-4 text-gray-500" />
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Body variant="caption" color="tertiary">
            Amount
          </Body>
          <Body className="font-semibold">{formatCurrency(paymentResult.amount)}</Body>
        </div>

        <div className="flex justify-between items-center">
          <Body variant="caption" color="tertiary">
            Equivalent unit
          </Body>
          <Body>{paymentResult.equivalentUnit}</Body>
        </div>

        <div className="flex justify-between items-center">
          <Body variant="caption" color="tertiary">
            Payment Date
          </Body>
          <Body>
            {new Date(paymentResult?.paymentDate!).toLocaleDateString("en-US", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </Body>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="w-full mt-6 flex gap-3 justify-center">
        <Button onClick={handleClose} variant="outline" className="w-full  ">
          Close
        </Button>
        <Button size="sm" className="w-full" disabled={downloadingReceipt} onClick={handleDownloadReceipt}>
          Download receipt
        </Button>
      </div>
    </PaymentStatusCard>
  );
};

export default SuccessStep;